if (typeof window.CartDiscountModule === 'undefined') {
  window.CartDiscountModule = {
    initialize: function() {
      // Add error message styles to the document head if not already present
      if (!document.getElementById('discount-error-styles')) {
        const style = document.createElement('style');
        style.id = 'discount-error-styles';
        style.textContent = `
          .discount-error-message {
            color: #d82c0d !important;
            font-size: 12px !important;
            font-weight: 500 !important;
            font-family: tenon, sans-serif !important;
            margin-top: 5px !important;
            display: none !important;
            margin-left: 5px !important;
            line-height: 1.3 !important;
          }
          
          .discount-error-message.show {
            display: block !important;
          }
          
          /* Error state styling for discount input */
          .discount-input-group.error {
            border: 2px solid #d82c0d !important;
            border-radius: 6px;
          }
        `;
        document.head.appendChild(style);
      }

      // Check if toggle should be open (from localStorage or if discount is applied)
      const discountToggle = document.querySelector('.discount-toggle');
      const discountContent = document.getElementById('discount-content');
      const hasAppliedDiscount = document.querySelector('#discount-input.has-discount');
      
      // Only restore toggle state if there's an applied discount, otherwise reset to closed
      const shouldBeOpen = hasAppliedDiscount; // Remove localStorage persistence
      
      if (discountToggle && discountContent) {
        if (shouldBeOpen) {
          discountToggle.setAttribute('aria-expanded', 'true');
          discountContent.hidden = false;
        } else {
          // Reset to default closed state
          discountToggle.setAttribute('aria-expanded', 'false');
          discountContent.hidden = true;
          // Clear any stored state
          localStorage.removeItem('discount-toggle-open');
        }
      }

      // Toggle functionality
      if (discountToggle && discountContent) {
        // Remove existing event listeners by cloning
        const newToggle = discountToggle.cloneNode(true);
        discountToggle.parentNode.replaceChild(newToggle, discountToggle);
        
        newToggle.addEventListener('click', function() {
          const expanded = this.getAttribute('aria-expanded') === 'true';
          this.setAttribute('aria-expanded', !expanded);
          discountContent.hidden = expanded;
          
          // Announce to screen readers
          const announcer = document.querySelector('.cart-update-announcement');
          if (announcer) {
            announcer.textContent = expanded ? 
              'Discount code form collapsed' : 'Discount code form expanded';
            setTimeout(() => { announcer.textContent = ''; }, 1000);
          }
        });
      }
      
      // Discount code functionality
      let enteredDiscountCode = '';
      const self = this; // Store reference to this for use in nested functions
      
      function reloadCart() {
        const targetUrl = '/cart.js';
        fetch(targetUrl, {method: 'GET'})
          .then(res => res.json())
          .then(data => {
            const appliedDiscounts = [];
            
            // Check cart-level discounts
            if (data.cart_level_discount_applications) {
              data.cart_level_discount_applications.forEach((discount) => {
                if (discount.type === 'discount_code') {
                  appliedDiscounts.push(discount.title);
                }
              });
            }
            
            // Check line-level discounts
            if (data.items) {
              data.items.forEach((item) => {
                if (item.line_level_discount_allocations) {
                  item.line_level_discount_allocations.forEach((discount) => {
                    if (discount.discount_application && discount.discount_application.type === 'discount_code') {
                      appliedDiscounts.push(discount.discount_application.title);
                    }
                  });
                }
              });
            }
            
            // Check if discount was applied
            if (appliedDiscounts.indexOf(enteredDiscountCode) === -1) {
              // Show invalid code in input field with remove button (like success state)
              self.showInvalidCodeInInput(enteredDiscountCode);
            } else {
              // Success! Keep the toggle open and reload the page
              localStorage.setItem('discount-toggle-open', 'true');
              window.location.reload();
            }
          });
      }

      // Function to show invalid code in input field with remove button
      this.showInvalidCodeInInput = function(invalidCode) {
        const discountInput = document.getElementById('discount-input');
        const discountInputGroup = document.querySelector('.discount-input-group');
        const errorMessage = document.getElementById('discount-error-message');
        const applyBtn = document.getElementById('apply-discount-btn');
        
        if (discountInput && discountInputGroup) {
          // Set the invalid code in the input - keep it editable and focusable
          discountInput.value = invalidCode;
          discountInput.classList.add('has-error');
          discountInput.readOnly = false; // Keep it editable so user can modify
          discountInput.disabled = false; // Ensure it's not disabled
          
          // Make sure the input is clickable and focusable
          discountInput.style.pointerEvents = 'auto';
          discountInput.style.cursor = 'text';
          
          // Add click event to focus the input when clicked
          discountInput.addEventListener('click', function() {
            this.focus();
            this.select(); // Select all text for easy editing
          });
          
          // Add focus event to clear error when focused
          discountInput.addEventListener('focus', function() {
            // Clear error styling when user focuses to edit
            if (errorMessage) {
              errorMessage.classList.remove('show');
              errorMessage.innerHTML = '';
            }
            
            if (discountInputGroup) {
              discountInputGroup.classList.remove('error');
            }
            
            // Remove error class from input
            this.classList.remove('has-error');
          });
          
          // Add error styling
          discountInputGroup.classList.add('error');
          
          // Show error message
          if (errorMessage) {
            const errorText = window.cartDiscountStrings?.errorInvalid || 
                          'This discount code is invalid or cannot be applied to your cart.';
            errorMessage.innerHTML = `<span>${errorText}</span>`;
            errorMessage.classList.add('show');
          }
          
          // Keep apply button visible but update text
          if (applyBtn) {
            applyBtn.style.display = '';
            applyBtn.textContent = 'Apply';
            applyBtn.disabled = false;
          }
          
          // DO NOT create error indicator - no icon in error state
          // Remove any existing indicators
          const existingErrorIndicator = discountInputGroup.querySelector('.error-applied-indicator');
          const existingRemoveBtn = discountInputGroup.querySelector('.remove-error-inline');
          if (existingErrorIndicator) existingErrorIndicator.remove();
          if (existingRemoveBtn) existingRemoveBtn.remove();
        }
      };

      // Function to clear error state and reset form
      this.clearErrorState = function() {
        const discountInput = document.getElementById('discount-input');
        const discountInputGroup = document.querySelector('.discount-input-group');
        const errorMessage = document.getElementById('discount-error-message');
        const applyBtn = document.getElementById('apply-discount-btn');
        
        // Clear error classes but keep the input value for user to edit
        if (discountInput) {
          discountInput.classList.remove('has-error');
          discountInput.readOnly = false;
          discountInput.disabled = false;
          // Don't clear the value - let user edit it
        }
        
        // Remove error styling
        if (discountInputGroup) {
          discountInputGroup.classList.remove('error');
        }
        
        // Hide error message
        if (errorMessage) {
          errorMessage.classList.remove('show');
          errorMessage.innerHTML = '';
        }
        
        // Show apply button again
        if (applyBtn) {
          applyBtn.style.display = '';
          applyBtn.textContent = window.cartDiscountStrings?.applyButtonText || 'Apply';
          applyBtn.disabled = false;
        }
        
        // Remove any error indicators (though we shouldn't have any)
        const errorIndicator = discountInputGroup?.querySelector('.error-applied-indicator');
        const removeBtn = discountInputGroup?.querySelector('.remove-error-inline');
        if (errorIndicator) errorIndicator.remove();
        if (removeBtn) removeBtn.remove();
        
        // Reset entered discount code
        enteredDiscountCode = '';
      };
      
      // Apply discount button
      const applyDiscountBtn = document.getElementById('apply-discount-btn');
      if (applyDiscountBtn) {
        // Clone the button to remove any existing listeners
        const newApplyBtn = applyDiscountBtn.cloneNode(true);
        applyDiscountBtn.parentNode.replaceChild(newApplyBtn, applyDiscountBtn);
        
        newApplyBtn.addEventListener('click', function() {
          const discountInput = document.getElementById('discount-input');
          const errorMessage = document.getElementById('discount-error-message');
          const discountInputGroup = document.querySelector('.discount-input-group');
          
          // Reset error state
          if (errorMessage) {
            errorMessage.classList.remove('show');
            errorMessage.innerHTML = '';
          }
          
          if (discountInputGroup) {
            discountInputGroup.classList.remove('error');
          }
          
          // Get discount code
          const discountCode = discountInput ? discountInput.value.trim() : '';
          
          // Check if empty
          if (!discountCode || discountCode.length === 0) {
            if (errorMessage) {
              const errorText = window.cartDiscountStrings?.errorNoCode || 
                            'Please enter a discount code.';
              errorMessage.innerHTML = `<span>${errorText}</span>`;
              errorMessage.classList.add('show');
            }
            
            if (discountInputGroup) {
              discountInputGroup.classList.add('error');
            }
            return;
          }
          
          // Check if already applied - Get from data attributes
          // Update this to use data attributes instead of Liquid
          const discountCodes = [];
          document.querySelectorAll('[data-discount-code]').forEach(el => {
            discountCodes.push(el.dataset.discountCode);
          });
          
          if (discountCodes.indexOf(discountCode) !== -1) {
            if (errorMessage) {
              const errorText = window.cartDiscountStrings?.errorAlreadyApplied || 
                            'This discount code has already been applied.';
              errorMessage.innerHTML = `<p>${errorText}</p>`;
              errorMessage.classList.add('show');
            }
            
            if (discountInputGroup) {
              discountInputGroup.classList.add('error');
            }
            return;
          }
          
          // Set loading state
          newApplyBtn.textContent = 'Applying...';
          newApplyBtn.disabled = true;
          
          if (discountInput) {
            discountInput.disabled = true;
          }
          
          // Store code for validation
          enteredDiscountCode = discountCode;
          
          // Apply the discount
          discountCodes.push(discountCode);
          const targetUrl = '/checkout?discount=' + discountCodes.join(',');
          fetch(targetUrl, {method: 'GET'})
            .finally(() => {
              reloadCart();
            });
        });
      }
      
      // Enter key in discount input
      const discountInput = document.getElementById('discount-input');
      if (discountInput) {
        // Clone to remove existing listeners
        const newInput = discountInput.cloneNode(true);
        discountInput.parentNode.replaceChild(newInput, discountInput);
        
        newInput.addEventListener('keypress', function(e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            const applyBtn = document.getElementById('apply-discount-btn');
            if (applyBtn) {
              applyBtn.click();
            }
          }
        });
        
        // Clear error on input
        newInput.addEventListener('input', function() {
          const errorMessage = document.getElementById('discount-error-message');
          const discountInputGroup = document.querySelector('.discount-input-group');
          
          // Clear error state when user starts typing
          if (errorMessage) {
            errorMessage.classList.remove('show');
            errorMessage.innerHTML = '';
          }
          
          if (discountInputGroup) {
            discountInputGroup.classList.remove('error');
          }
          
          // Remove error class from input
          if (this.classList.contains('has-error')) {
            this.classList.remove('has-error');
          }
          
          // Reset entered discount code since user is modifying
          enteredDiscountCode = '';
        });
      }
      
      // Remove discount button
      const removeDiscountBtn = document.querySelector('.remove-discount-inline');
      if (removeDiscountBtn) {
        // Clone to remove existing listeners
        const newRemoveBtn = removeDiscountBtn.cloneNode(true);
        if (removeDiscountBtn.parentNode) {
          removeDiscountBtn.parentNode.replaceChild(newRemoveBtn, removeDiscountBtn);
        }
        
        newRemoveBtn.addEventListener('click', function() {
          // Set loading state
          const discountInput = document.getElementById('discount-input');
          if (discountInput) {
            discountInput.disabled = true;
          }
        
          const targetUrl = '/checkout?discount=';
          fetch(targetUrl, {method: 'GET'})
            .finally(() => {
              window.location.reload();
            });
        });
      }
    }
  };
}

// Initialize the module
document.addEventListener('DOMContentLoaded', window.CartDiscountModule.initialize);
document.addEventListener('cart-updated', function(event) {
  if (!event.detail || event.detail.source !== 'discount-module') {
    window.CartDiscountModule.initialize();
  }
});